import React from "react";
import GameDetails from "./GameDetails";
import { flunkyInstructionIcons } from "./flunkyInstructionIcons";

const Holzfaellern: React.FC = () => (
    <GameDetails
        game="holzfaellern"
        tagColor="blue"
        instructionIcons={flunkyInstructionIcons}
    />
);

export default Holzfaellern;
